module.exports = __webpack_public_path__ + "img/error.03bcea7d.png";